// extracted by mini-css-extract-plugin
module.exports = {"button":"PortalManagementPageView_button__4U97u"};